import BaseService from "./base.service";
const service = new BaseService("/divalto_agencies/:id/divalto_agency_members")
export default service;
